/**
 * RFC-4122 v4 UUID. Prefers the native crypto implementation and falls back to
 * a getRandomValues-based generator, then Math.random, so it never throws in
 * older webviews (the Eitaa miniapp host can be dated).
 */
export const uuid = (): string => {
  const cryptoObj = typeof crypto !== "undefined" ? crypto : undefined;

  if (cryptoObj?.randomUUID) {
    return cryptoObj.randomUUID();
  }

  if (cryptoObj?.getRandomValues) {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0"));
    // The byte slices already lay out the 8-4-4-4-12 groups, so the string is
    // finished here. Re-splitting it by raw character counts would count the
    // dashes below as payload and emit a second, misaligned set of them.
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
      .slice(6, 8)
      .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
